angular.module('zc.projects')

.controller 'CampaignsCtrl', (
    $filter,
    $scope,
    $state,
    $translate,
    $modal,
    Campaign,
    Devise,
    InterestWidget,
    Page,
    SearchFilter,
    campaigns,
    currentProject,
    currentUser,
    incentives,
    interestWidgets) ->
  Page.setBodyClass ''
  $translate('projectsCampaigns.listController.campaignList').then (translation) ->
    Page.setTitle translation

  $scope.interestWidgets = interestWidgets

  $scope.Devise = Devise
  $scope.currentProject = currentProject
  $scope.currentUser = currentUser
  $scope.loginBeforePR =  moment(currentUser.last_sign_in_at) < moment.tz('2019-10-15', 'Asia/Tokyo') && currentUser.lang == 'ja'
  $scope.incentives = incentives
  $scope.filters = SearchFilter.resolveFromLocation()
  $scope.isCampaignSelected = false
  $scope.allCampaigns = []
  hideInvoiceAmount = currentProject.product_line is 'zenclerk_lp' and currentProject.pricing_type is 'minimum_charge'
  $scope.canShowInvoiceAmount = if Devise.isCommonUser() or hideInvoiceAmount then false else true


  $scope.newCampaign = ->
    Campaign.create
      projectId: currentProject.id
    .then (res) ->
      $state.go 'admin.projects.campaigns.edit',
        projectId: currentProject.id
        campaignId: res.campaign.id

  $scope.newInterestWidget = ->
    $state.go 'admin.projects.interestWidget.new'

  $scope.editWidget = (interestWidget) ->
    $state.go 'admin.projects.interestWidget.show', {id: interestWidget.id}

  $scope.reload = ->
    $state.reload()

  $scope.openModal = ->
    $modal.open
      templateUrl: '/templates/projects.campaigns/campaign_bulk_edit_modal.html'
      controller: 'CampaignBulkEditModalController'
      controllerAs: 'vm'
      size: 'lg'
      resolve:
        project: -> $scope.currentProject
        incentives: -> $scope.incentives
        campaigns: -> _.filter $scope.allCampaigns, selected: true

  findInterestWidget = (campaign) ->
    _.find(interestWidgets, (iw) -> (iw.campaign.id is campaign.id))

  $scope.isAb = false
  $scope.hasHiddenAb = false
  $scope.showHiddenAb = false
  $scope.iwDevices = []
  $scope.multiIncentiveDevices = []
  $scope.filterCampaigns = ->
    $scope.allCampaigns = []
    $scope.previewCampaigns = []
    $scope.incompleteCampaigns = []
    $scope.filteredCampaigns = []

    for campaign in campaigns
      if $scope.filters.search_term and campaign.name and campaign.name.indexOf($scope.filters.search_term) is -1
        continue

      iw = findInterestWidget campaign
      if iw and Devise.isMaster()
        campaign.iw_current_status = iw.status
        if campaign.iw_current_status is 'preview'
          $scope.previewCampaigns.push campaign
        else if campaign.iw_current_status isnt 'enable' and campaign.iw_current_status isnt 'disable'
          $scope.incompleteCampaigns.push campaign
        else
          $scope.filteredCampaigns.push campaign
        if campaign.iw_current_status in ['preview', 'enable']
          $scope.iwDevices.push campaign.campaign_device
      else
        $scope.allCampaigns.push campaign
        if campaign.current_status is 'preview'
          $scope.previewCampaigns.push campaign
        else if campaign.current_status is 'incomplete'
          $scope.incompleteCampaigns.push campaign
        else
          $scope.filteredCampaigns.push campaign
      if campaign.template_type in ['multi_incentive', 'multi_incentive_sp'] and
         campaign.current_status in ['preview', 'active']
        $scope.multiIncentiveDevices.push campaign.campaign_device

    $scope.iwDevices = _.uniq $scope.iwDevices
    $scope.multiIncentiveDevices = _.uniq $scope.multiIncentiveDevices

    $scope.filteredCampaigns = $filter('campaign')($scope.filteredCampaigns, $scope.filters)
    $scope.isAb = _.some $scope.filteredCampaigns, (campaign) ->
      campaign.campaign_control_percent isnt 0 and not campaign.is_secret_ab
    $scope.hasHiddenAb = _.some $scope.filteredCampaigns, (campaign) ->
      campaign.campaign_control_percent isnt 0 and campaign.is_secret_ab

    $scope.updatedFilters =
      start_at: moment($scope.filters.start_at).startOf('day').valueOf()
      end_at: moment($scope.filters.end_at).endOf('day').valueOf()
    SearchFilter.set($scope.filters)

  $scope.resetFilters = () ->
    $scope.filterCampaigns()

  $scope.filterCampaigns()

  $scope.$watch 'allCampaigns', (allCampaigns) ->
    $scope.isCampaignSelected = _.some allCampaigns, selected: true
  , true



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.campaigns/list.controller.js.coffee